import { type ActionEvent, Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

import SearchMapController from "./search_map_controller"

import { urlWithBounds } from "@/helpers/search_map"

const NEW_SEARCH_PAGE = document.body.getAttribute("data-new-search-page") === "true"

export default class SearchFiltersController extends Controller {
  static outlets = ["search-map"]
  declare readonly searchMapOutlet: SearchMapController

  static targets = ["hiddenFieldset"]
  declare readonly hiddenFieldsetTargets: HTMLFieldSetElement[]

  connect(): void {
    if (!NEW_SEARCH_PAGE) {
      ;(this.element as HTMLFormElement).reset()
    }
  }

  applyFilter(e: Event): void {
    e.preventDefault()

    let url

    if (NEW_SEARCH_PAGE) {
      const anchor = e.currentTarget as HTMLAnchorElement

      if (anchor.getAttribute("aria-disabled") === "true") {
        return
      }

      url = urlWithBounds(anchor.href, this.searchMapOutlet.mapBounds)
    } else {
      const filter = e.currentTarget as HTMLElement
      url = urlWithBounds(filter.dataset.url!, this.searchMapOutlet.mapBounds)
    }

    Turbo.visit(url.toString(), {
      frame: this.element.closest("turbo-frame")!.id,
      action: "advance" // This is supposed to be default but spinner doesn't work unless explicit
    })
  }

  scrollIntoView({ currentTarget }: ActionEvent): void {
    ;(currentTarget as HTMLElement).scrollIntoView({
      behavior: "instant",
      block: "nearest", // To avoid vertical scrolls
      inline: "center"
    })
  }

  // TODO[NEW_SEARCH_PAGE]: Remove this function (and target) when feature switch gone.
  showAll(e: Event): void {
    const button = e.currentTarget as HTMLButtonElement
    const hiddenFilters = this.hiddenFieldsetTargets.find((fieldset) => {
      return button.parentElement?.contains(fieldset)
    })

    hiddenFilters?.removeAttribute("hidden")
    button?.remove()
  }
}
